import React,{useState,useRef,useEffect} from 'react';
import {NavLink, useHistory, useParams, useLocation } from 'react-router-dom';
import {useFormikContext} from 'formik';

import {useModal, useFetch} from 'helpers/hooks';
import {ActionButton} from 'components/ActionButton';
import {Button} from 'components/Button';
import {CaptureButton} from 'components/CaptureButton';
import {EditForm} from 'components/EditForm';
import {FilePreview} from 'components/FilePreview';
import {RejectModal} from 'components/RejectModal';
import {DirectRejectModal} from 'components/DirectRejectModal';
import {RemoveAssignedModal} from "./RemoveAssignedModal";
import {RemoveModal} from 'components/RemoveModal';
import {ReactComponent as ChevronLeft} from 'assets/svg/2_chevron_left.svg';
import {ReactComponent as ChevronRight} from 'assets/svg/2_chevron_right.svg';
import {ReactComponent as AI} from 'assets/svg/2_ai-magic.svg';
import {NotificationLogo} from 'components/NotificationLogo'
import { request } from "helpers/tools";
import {SaveModal} from './SaveModal';

import Split from '@uiw/react-split';

import {ReactComponent as Delete} from 'assets/svg/2_delete.svg';

import styles from 'css_modules/Detail.module.css';

export const Detail = (
    {canCapture, canEdit, detail, doc, setDocUuid, permissions, role,user, setForwarding, requiredFields, setDuplicates,formInitValues, page,setShowNotifications, ...props}
) => {
    const history = useHistory();
    let {table, uuid} = useParams();
    let location = useLocation();
    let [nextLocation,setNextLocation] = useState("")
    const [noteChanged, setNoteChanged] = useState(false);
    let [saving, setSaving] = useState(false);
    let [saveButtonTitle, setSaveButtonTitle] = useState('Uložit');
    const {submitForm, validateForm, values} = useFormikContext();
    const modify = location.pathname.split("/")[2] === "modify";
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [otherActionsOpen, setOtherActionsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOtherActionsOpen(false);
        }
    };

    if (otherActionsOpen) {
        document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [otherActionsOpen]);


    useEffect(() => {
        const resizeHandler = () => {
          if (windowWidth!==window.innerWidth){ setWindowWidth(window.innerWidth);
              
          }
        };
        
        window.addEventListener('resize', resizeHandler);
    
        return () => {
          window.removeEventListener('resize', resizeHandler);
        };
      }); 
  
    const editable = (doc.is_active && !doc.awaiting_capture && permissions.edit)||  location.pathname.split("/")[1]==="my_templates" ||  location.pathname.split("/")[2]==="modify";

    let docsList = sessionStorage.getItem("docsList");

    const [unassignModal, toggleUnassign] = useModal();
    const [rejectModal, toggleRejectModal] = useModal();
    const [directRejectModal, toggleDirectReject] = useModal();
    const [removeModal, toggleRemove] = useModal();

    function toggleReject  (doc) {
        if (user.direct_reject) {
            toggleDirectReject();
        } else {
            toggleRejectModal();
        }
    };

    const [search] = useState('')
    const [ordering] = useState('')
    
    const currentTable = location.pathname.split("/")[1];
    let docs = useFetch(
        '/'+currentTable+`/?search=${search}&ordering=${ordering}&page=${1}&limit=50`,
        null
    );
    
    let [docCustomType,setDocCustomType] = useState("")

    let cdt = useFetch('/get_user_type_for_documents/?documents='+[doc.uuid])
    let loadTemplateText = "Načíst ze šablony"
    
    
    if (cdt?.data?.[0]?.user_types?.[0]?.id && docCustomType==="" ){
        setDocCustomType(cdt.data[0].user_types[0].id)
    }


    const templates = useFetch(`/my_templates/?search=&active_only=false&page=1&limit=200`, null)   

    if (docsList){
        docsList = docsList.split(",");
    }
    else {
        docsList=[]
        if (docs.data){
            for (let i=0; i<docs.data?.results.length; i++){
                let el = docs.data?.results[i]
                docsList.push(el["uuid"])
            }
        }
    }
    
    let newuuids = []
    if (sessionStorage.getItem("newUuids")){
        newuuids = sessionStorage.getItem("newUuids").split(',')
    }
    
    if (newuuids.length>0){
        newuuids.forEach(e => {
            if (!docsList.includes(e)){
                docsList.unshift(e)
            }
        })
    }
    
    const isAccountant = role === 'AccountantUser';

    let modifyToggles = JSON.parse(sessionStorage.getItem("bulkDetailModifyToggles"))
    let isCashDeskDocType = ['ppr', 'pvy'].includes(values.info.document_type);
    if (modify === true &&!values.info["client_company"] && modifyToggles.any_desk && !values.info.document_type){
        isCashDeskDocType=true
    }

    const activeAndNotWaiting = doc.is_active && !doc.awaiting_capture;
    const rejectButton = permissions.reject && activeAndNotWaiting  //&& doc.added_by_client;
    const removeButton = permissions.remove && activeAndNotWaiting;
    const previousDocButton = true && table!=="my_templates" && modify===false;
    const nextDocButton =  true  && table!=="my_templates" && modify===false;
    
    const unassignButton = permissions.accessDocuments && activeAndNotWaiting;
    const isOrgUnitAdmin = role === "OrganizationUnitAdmin";
    const captureButton = (canCapture && activeAndNotWaiting && !doc.captured)||isOrgUnitAdmin
    const primaryButtonIsVisible = (table === 'documents' || activeAndNotWaiting) && !isOrgUnitAdmin ;
 

    let myidx = docsList.findIndex(obj => obj === doc.uuid)  
    let nextuuid = undefined
    let prevuuid = undefined
   
    if (myidx!==-1){
        try{
            prevuuid = docsList[myidx+1]
            nextuuid =docsList[myidx-1]
        }
        catch (error){
        }
    }
    
    const editFormRef = useRef(null)
    
    let myloc = window.location.href.split("/")[window.location.href.split("/").length-1]
    const [targetuuid, setTargetUUID] = useState('')
    const [savemodal, togglesavemodal] = useModal();
    let [differences, setDifferences] = useState([]);
    let forceMove = false

    const saveFunction = () => {
        editFormRef.current.onSaveButtonClick()
        setDifferences(-1)
        console.log("Differences")
        console.log(differences)
    }

  let currentLocation =location.pathname
    
  useEffect(() => {
    const unlisten = history.block((location) => {
        setNextLocation(location.pathname)
        let diff = editFormRef.current.isSaveNeeded(formInitValues)
        if (modify === true){
            diff = diff.filter(item => item !== "document_type");
        }

        console.log("movingaway to " + location.pathname + " from " + currentLocation)
        let stayingInModify = location.pathname.includes("modify") && currentLocation.includes("modify")

        if (stayingInModify===false && differences!==-1 && sessionStorage.getItem("forceMove")!== "0" && diff.length > 0  && forceMove===false && !location.pathname.includes(doc.uuid)) {
            setDifferences(diff)
            togglesavemodal()
            return false;
        }
     return true;
    });

    return () => {
      unlisten();
    };
  }, [formInitValues,history,togglesavemodal,forceMove,doc.uuid,differences,currentLocation,modify]);
  
  const redirectAway = () => {
    if (targetuuid!==''){
        let t = targetuuid==='next' ? nextuuid : prevuuid
        history.replace('/'+currentTable+'/'+t+'/'+myloc, '')
        window.location.reload()
    }
    else{
        history.replace(nextLocation,'')
        //window.location.reload()
    }
    forceMove = false
  }

  useEffect (() =>{
    //console.log('target changed ' + targetuuid)
  },[targetuuid])
  

    const  modalClickedSave = async () => {
        forceMove=true
        await editFormRef.current.onSaveButtonClick(false)
      
        togglesavemodal();
        redirectAway()
    }

    const modalClickedClose = () => {
        forceMove=true
        togglesavemodal();
        redirectAway()
    }
    
    const goPrev =()=>{goPrevious()}
    const goNex =()=>{goNext()}
    const goPrevious = () => {
        //console.log('goprev ' + prevuuid)
        let diff = editFormRef.current.isSaveNeeded(formInitValues)
        setDifferences(diff)

        if (sessionStorage.getItem("saverequired")==="1"){
            setTargetUUID('prev')
            togglesavemodal();
        }
        else{
            history.push('/'+currentTable+'/'+prevuuid+'/'+myloc, '')
            //update(prevuuid)
            //if (!['general', 'costs','metadata'].includes(myloc))
            window.location.reload()
        }
    
    }

    const goNext = () => {
        //console.log('gonext ' + nextuuid)
        let diff = editFormRef.current.isSaveNeeded(formInitValues)
        setDifferences(diff)

        if (sessionStorage.getItem("saverequired")==="1"){
            setTargetUUID('next')
            togglesavemodal();
        }
        else{
            history.push('/'+currentTable+'/'+nextuuid+'/'+myloc, '')
            //update(nextuuid)
            //if (!['general', 'costs','metadata'].includes(myloc))
            window.location.reload()
        }
        
    }

    const update = (newuuid) => {
        //setDocUuid(newuuid);
        //formInitValues=values
        //detail.fetchData(); // update history
    }

    const [previewDoc, setPreviewDoc] = useState(doc)
    const [lastResponse, setLastResponse] = useState(doc)
    const [refresh, setRefresh] = useState(false);

   

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const delay = async () => {
            await new Promise(resolve => setTimeout(resolve, 5000));
           
          };

        delay()
        if (refresh===true){
        const fetchData = async () => {
            try {
              const url = `/${table}/${uuid}/`
                const response = await fetch(`${process.env.REACT_APP_API}${url}`, {
                headers: {
                  'Authorization': 'JWT ' + localStorage.getItem('DocspointJWT'),
                  'Content-Type': 'application/json'
                },
              });

              
              let resp =  await response.json();
             
              if (JSON.stringify(lastResponse) !== JSON.stringify(resp)){
                setLastResponse(resp)
                setPreviewDoc(resp);
              }
              
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
          fetchData();
          setRefresh(false)
        }
    }, [table,uuid,refresh,lastResponse]); 

    const updateFile = async () => {
       setRefresh(true);
   }

    const redirect = () => history.push('/my_documents');
        
    let pageTitle = doc.name;
    if (detail.data.info.state==="tpl"){
        pageTitle = "Šablona: " + doc.document_info['template_name'];
    }
    if (detail.data.info.state==="tpl" && modify===true){
        let docsnr = JSON.parse(sessionStorage.getItem("bulkDetailModifyUUIDS")).length
        pageTitle="Hromadná úprava " + docsnr + " šablon"
    }
    else if (doc.document_info['document_identifier']){
        pageTitle = doc.document_info['document_identifier'];
    }
    else if (modify===true){
        let docsnr = JSON.parse(sessionStorage.getItem("bulkDetailModifyUUIDS")).length
        pageTitle="Hromadná úprava " + docsnr + " dokladů"
    }

    const divRef = useRef(null);
    let prevPane = parseFloat(sessionStorage.getItem("prevPaneDetail"+user.pk))
    if (prevPane!==undefined && !isNaN(prevPane)){  }
    else{  
         prevPane=40 
         sessionStorage.setItem("prevPaneDetail"+user.pk, 40);
     }
   
    let minWidthLeft = 42
    if (values.items.length===0){minWidthLeft = 42}

    if (table==="my_templates"){prevPane=30}

    let loadFromTemplate = () => {
        editFormRef.current.handleLoadTemplate()
    }

    let loadFromAI = () => {
        const handleAISubmit = async () => {
            const body = {
              id: doc.id,
              accounting_company_id: user.company_title,
              supplier_title: doc.document_info.supplier_title,
              batch_size: 3,
            };
            const response = await request("/recommendations/", 'POST', body);
            return response
          }
          const res = handleAISubmit()
          console.log(res)

        editFormRef.current.handleLoadAI()
    }

    let cancelButtonClick = () => {
        editFormRef.current.handleCancelButtonClick()
    }

    let saveButtonClick = () => {
        editFormRef.current.onSaveButtonClick(false)
    }
    
    const shouldDisplaySaveButton = () =>
        (noteChanged && permissions.edit) || editable;
        

    
    const handleResize = (preSize, nextSize, paneNumber) => {
        sessionStorage.setItem("prevPaneDetail"+user.pk, nextSize);
      };
    
    const showAIButton = false// user.ai_agent && table === "my_documents" && !modify;

    if (windowWidth > 1224){
        return (
            <>
            <div className={styles.wrap}>
                <header className={styles.topRow}>
                     
                    <h1 className={styles.heading}>
                        <Button className={styles.backButton}> <ChevronLeft onClick={cancelButtonClick}/></Button>
                        {pageTitle}
                    </h1>
                    <div className={styles.actionButtons}>
                       
                       
                         {removeButton && <Button onClick={toggleRemove} className={styles.flushbutton}><Delete /></Button>}
                        {((table==="my_documents" && doc.is_active)|| isOrgUnitAdmin)&&
                        <div
                            ref={dropdownRef}
                            className={`${styles.dropdownWrapper} ${otherActionsOpen ? styles.open : ""}`}
                        >

                            <Button
                                className={styles.secondaryButton + " " + styles.ostatniButton}
                                onClick={() => setOtherActionsOpen(o => !o)}
                            >
                                Další akce
                                <span
                                    style={{ marginLeft: "0.6rem", marginRight: "-0.5rem" }}
                                    className={`${styles.chevron} }`}
                                >
                                   {!otherActionsOpen && <ChevronLeft/>} 
                                   {otherActionsOpen && <ChevronRight/>} 
                                </span>
                            </Button>
                           

                            <div
                                className={styles.dropdownMenu}
                                onClick={() => setOtherActionsOpen(false)}
                            >
                                    
                                {captureButton && <CaptureButton user={user} className={styles.dropdownItem} docs={[doc]} update={redirect} saveFunction={saveFunction} />}
                                {(templates.data&& !isOrgUnitAdmin) && <Button className={styles.dropdownItem} onClick={loadFromTemplate}>{loadTemplateText}</Button>}
                                 {rejectButton && <Button className={styles.dropdownItem} onClick={toggleReject}>Vrátit</Button>}
                                {unassignButton && <Button className={styles.dropdownItem} onClick={toggleUnassign}>Zrušit přiřazení</Button>}
                               
                            </div>
                        </div>
                        }
                        {modify ===true &&
                            <>{templates.data && <Button className={styles.secondaryButton} onClick={loadFromTemplate}>{loadTemplateText}</Button>}</>
                        }
                        {shouldDisplaySaveButton() && <Button onClick={saveButtonClick} disabled={saving} className={styles.secondaryButton} > {saveButtonTitle} </Button>}
                        {primaryButtonIsVisible &&
                        <ActionButton
                            className={styles.actionButton}
                            forward={doc.is_active}
                            data={uuid}
                            user={user}
                            canEdit={canEdit}
                            setDuplicates={setDuplicates}
                            submitForm={submitForm}
                            validateForm={validateForm}
                            setForwarding={setForwarding}
                            saveFunction={saveFunction}
                            miscellaneousDocType={doc.document_info.document_type==='rzn'}
                            detaildoc={doc}
                        />
                        }
                        <div className={styles.prevNextCouple}>
                        {savemodal && <SaveModal clickedSave={modalClickedSave} clickedClose={modalClickedClose} diff={differences} close={togglesavemodal} />}
                        {previousDocButton &&  <Button onClick={goPrev} disabled={!prevuuid}  className={styles.prevButton}>  <ChevronLeft /> </Button>}
                        {nextDocButton && <Button onClick={goNex}  disabled={!nextuuid}  className={styles.nextButton}>      <ChevronRight /> </Button>}
                        <NotificationLogo user={user.pk} display={user.display_notifications} notifications={user.notifications} setShowNotifications={setShowNotifications} />
                        </div>
                    </div>
                    
                </header>
                <section className={styles.container}>
                    <Split
                        onDragEnd={handleResize}
                        renderBar={({ onMouseDown, ...props }) => (
                            <div
                                {...props}
                                visible={table!=="my_templates"}
                                onMouseDown={onMouseDown}
                                style={{
                                    width: '0.6rem',                   
                                    height: '100%',                   
                                    backgroundColor: 'var(--semilight)',
                                    cursor: 'col-resize',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',             
                                        flexDirection: 'row',        
                                        justifyContent: 'center',    
                                        alignItems: 'center',       
                                        gap: '2px',                 
                                        height: '100%'              
                                    }}
                                >
                                    <span
                                        style={{
                                            width: '2px',            
                                            height: '3rem',            
                                            backgroundColor: 'var(--purple)',
                                            borderRadius: '2px',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                    <span
                                        style={{
                                            width: '2px',
                                            height: '3rem',
                                            backgroundColor: 'var(--purple)',
                                            borderRadius: '2px',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    >



                    <div ref={divRef} style={{ minWidth: `${minWidthLeft}em`, width: `${100 - prevPane}%` }}>
                        <div className={styles.main}>
                        <nav className={styles.navRow}>
                            <NavLink
                            to={`/${table}/${uuid}/general`}
                            activeClassName={styles.menuItemActive}
                            className={styles.menuItem}
                            >
                            Obecné
                            </NavLink>
                            <NavLink
                            to={`/${table}/${uuid}/supplier`}
                            activeClassName={styles.menuItemActive}
                            className={styles.menuItem}
                            >
                            Partner
                            </NavLink>
                            {
                            <NavLink
                                to={`/${table}/${uuid}/payment`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Platba
                            </NavLink>
                            }
                             {modify===false && <NavLink
                            to={`/${table}/${uuid}/costs`}
                            activeClassName={styles.menuItemActive}
                            className={styles.menuItem}
                            >
                            Náklady
                            </NavLink>}
                            <NavLink
                                to={`/${table}/${uuid}/accounting`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Účtování
                            </NavLink>
                             {modify===false && 
                             <NavLink
                            to={`/${table}/${uuid}/history`}
                            activeClassName={styles.menuItemActive}
                            className={styles.menuItem}
                            >
                            Historie
                            </NavLink>}
                            {modify===false && <NavLink
                            to={`/${table}/${uuid}/metadata`}
                            activeClassName={styles.menuItemActive}
                            className={styles.menuItem}
                            >
                            Metadata
                            </NavLink>}
                            {showAIButton && <button onClick={loadFromAI} secondary className={styles.aibutton}><AI/></button>}
                            {!showAIButton && <div></div>}
                            
                        </nav>
                        <EditForm
                            innerRef={editFormRef}
                            initialValues={formInitValues}
                            doc={doc}
                            detail={detail.data}
                            permissions={permissions}
                            isCashDeskDocType={isCashDeskDocType}
                            isAccountant={isAccountant || isOrgUnitAdmin}
                            requiredFields={requiredFields}
                            user={user}
                            update={update}
                            setDuplicates={setDuplicates}
                            docCustomType={docCustomType}
                            setDocCustomType={setDocCustomType}
                            setNoteChanged={setNoteChanged}
                            setSaving={setSaving}
                            setSaveButtonTitle={setSaveButtonTitle}
                            {...props}
                        />
                        </div>
                    </div>
                    <div style={{  minWidth: "30rem", width:`${prevPane}%`,height:"100%",position: "relative",zIndex:60}}>
                        {detail.data.info.state !== "tpl" && <FilePreview detailHeight={true} doc={previewDoc} refresh={updateFile} />}
                    </div>
                    </Split>

                </section>
                {unassignModal && <RemoveAssignedModal close={toggleUnassign} doc={doc} update={redirect} user={role}/>}
                {rejectModal && <RejectModal doc={doc} close={toggleRejectModal} update={redirect}/>}
                {directRejectModal && <DirectRejectModal user={user} doc={doc} close={toggleDirectReject} update={redirect}/>}
                {removeModal && <RemoveModal close={toggleRemove} docs={[doc]} update={redirect} user={role}/>}
                </div>
                
            </>
        )
    }
    else{
        return (
            <>
                <header className={styles.topRow}>
                     
                    <h1 className={styles.heading}>
                        <Button className={styles.backButton}> <ChevronLeft onClick={cancelButtonClick}/></Button>
                        {pageTitle}
                    </h1>
                    <div className={styles.actionButtons}>
                       
                        
                         {removeButton && <Button onClick={toggleRemove} className={styles.flushbutton}><Delete /></Button>}
                        {(table==="my_documents" && doc.is_active)&&
                        <div
                            ref={dropdownRef}
                            className={`${styles.dropdownWrapper} ${otherActionsOpen ? styles.open : ""}`}
                        >

                            <Button
                                className={styles.secondaryButton + " " + styles.ostatniButton}
                                onClick={() => setOtherActionsOpen(o => !o)}
                            >
                                Další akce
                                <span
                                    style={{ marginLeft: "0.6rem", marginRight: "-0.5rem" }}
                                    className={`${styles.chevron} }`}
                                >
                                   {!otherActionsOpen && <ChevronLeft/>} 
                                   {otherActionsOpen && <ChevronRight/>} 
                                </span>
                            </Button>

                            <div
                                className={styles.dropdownMenu}
                                onClick={() => setOtherActionsOpen(false)}
                            >

                                {captureButton && <CaptureButton  user={user} className={styles.dropdownItem} docs={[doc]} update={redirect} saveFunction={saveFunction} />}
                                {templates.data && <Button className={styles.dropdownItem} onClick={loadFromTemplate}>{loadTemplateText}</Button>}
                                 {rejectButton && <Button className={styles.dropdownItem} onClick={toggleReject}>Vrátit</Button>}
                                {unassignButton && <Button className={styles.dropdownItem} onClick={toggleUnassign}>Zrušit přiřazení</Button>}
                               
                            </div>
                        </div>
                        }
                        {modify ===true &&
                            <>{templates.data && <Button className={styles.secondaryButton} onClick={loadFromTemplate}>{loadTemplateText}</Button>}</>
                        }
                        {shouldDisplaySaveButton() && <Button onClick={saveButtonClick} disabled={saving} className={styles.secondaryButton} > {saveButtonTitle} </Button>}
                        {primaryButtonIsVisible &&
                        <ActionButton
                            className={styles.actionButton}
                            forward={doc.is_active}
                            data={uuid}
                            user={user}
                            canEdit={canEdit}
                            setDuplicates={setDuplicates}
                            submitForm={submitForm}
                            validateForm={validateForm}
                            setForwarding={setForwarding}
                            saveFunction={saveFunction}
                            miscellaneousDocType={doc.document_info.document_type==='rzn'}
                            detaildoc={doc}
                        />
                        }
                        <div className={styles.prevNextCouple}>
                        {savemodal && <SaveModal clickedSave={modalClickedSave} clickedClose={modalClickedClose} diff={differences} close={togglesavemodal} />}
                          {previousDocButton &&  <Button onClick={goPrev} disabled={!prevuuid}  className={styles.prevButton}>  <ChevronLeft /> </Button>}
                        {nextDocButton && <Button onClick={goNex}  disabled={!nextuuid}  className={styles.nextButton}>      <ChevronRight /> </Button>}
                        <NotificationLogo user={user.pk} display={user.display_notifications} notifications={user.notifications} setShowNotifications={setShowNotifications} />
                        </div>
                    </div>
                    
                </header>
                <section className={styles.container}>
                    <div className={styles.main}>
                        <nav className={styles.navRow}>
                            <NavLink
                                to={`/${table}/${uuid}/general`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Obecné
                            </NavLink>
                            <NavLink
                                to={`/${table}/${uuid}/supplier`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Partner
                            </NavLink>
                            {!isCashDeskDocType && (
                                <NavLink
                                    to={`/${table}/${uuid}/payment`}
                                    activeClassName={styles.menuItemActive}
                                    className={styles.menuItem}
                                >
                                    Platba
                                </NavLink>
                            )}
                            {modify===false  &&<NavLink
                                to={`/${table}/${uuid}/costs`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Náklady
                            </NavLink>}
                            {(isAccountant || isOrgUnitAdmin) && (
                                <NavLink
                                    to={`/${table}/${uuid}/accounting`}
                                    activeClassName={styles.menuItemActive}
                                    className={styles.menuItem}
                                >
                                    Účtování
                                </NavLink>
                            )}
                            {modify===false &&<NavLink
                                to={`/${table}/${uuid}/history`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Historie
                            </NavLink>}
                            {modify===false && <NavLink
                                to={`/${table}/${uuid}/metadata`}
                                activeClassName={styles.menuItemActive}
                                className={styles.menuItem}
                            >
                                Metadata
                            </NavLink>}
                            {showAIButton && <button onClick={loadFromAI} secondary className={styles.aibutton}><AI/></button>}
                            {!showAIButton && <div></div>}
                        </nav>
                        <EditForm
                            innerRef={editFormRef}
                            initialValues={formInitValues}
                            doc={doc}
                            detail={detail.data}
                            permissions={permissions}
                            isCashDeskDocType={isCashDeskDocType}
                            isAccountant={isAccountant || isOrgUnitAdmin}
                            requiredFields={requiredFields}
                            user={user}
                            update={update}
                            setDuplicates={setDuplicates}
                            docCustomType={docCustomType}
                            setDocCustomType={setDocCustomType}
                            setNoteChanged={setNoteChanged}
                            setSaving={setSaving}
                            setSaveButtonTitle={setSaveButtonTitle}
                            {...props}
                        />
                    </div>
                    {detail.data.info.state!=="tpl" && <FilePreview doc={previewDoc} refresh={updateFile}/>}
                </section>
                {unassignModal && <RemoveAssignedModal close={toggleUnassign} doc={doc} update={redirect} user={role}/>}
                {rejectModal && <RejectModal doc={doc} close={toggleRejectModal} update={redirect}/>}
                {directRejectModal && <DirectRejectModal user={user} doc={doc} close={toggleDirectReject} update={redirect}/>}
                {removeModal && <RemoveModal close={toggleRemove} docs={[doc]} update={redirect} user={role}/>}
                
            </>
        )
    }
};